module.exports = __webpack_public_path__ + "img/gongdan_mobile2.7016cb98.jpg";